export const SET_NEW_POPUP = "SET_NEW_POPUP";
export const SET_EDIT_POPUP = "SET_EDIT_POPUP";
export const CLOSE_POPUP = "CLOSE_POPUP";
export const SAVE_CATEGORY_CHANGES = "SAVE_CATEGORY_CHANGES";


// WEBPACK FOOTER //
// ./src/_app/drafts/constants/popup-constants.js